"use client";

import { Clock, Mail, MapPin, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Separator } from "@/components/ui/separator";
import { Textarea } from "@/components/ui/textarea";
import { Link } from "@/components/common/Link";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
function ReachOutForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="p-8 border rounded-md" style={{
      borderColor: "var(--primary)",
      backgroundColor: "var(--background)"
    }}>
        <p className="text-lg font-default text-foreground">
          {successMessage}
        </p>
        <Button onClick={resetForm} variant="outline" className="mt-6 rounded-md border-[1.5px] font-default uppercase tracking-wider" style={{
        borderColor: "var(--foreground)",
        color: "var(--foreground)"
      }}>
          Invia un nuovo messaggio
        </Button>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-8">
      <FormField control={control} name="name" rules={{
      required: "Il nome è obbligatorio",
      minLength: {
        value: 2,
        message: "Minimo 2 caratteri"
      }
    }} render={({
      field
    }) => <FormItem>
            <FormLabel className="text-xs uppercase font-mono" style={{
        letterSpacing: "0.2em",
        color: "var(--muted-foreground)"
      }}>
              Nome Completo
            </FormLabel>
            <FormControl>
              <Input placeholder="Mario Rossi" className="bg-transparent border-0 border-b px-0 focus-visible:ring-0 focus-visible:border-b-2 transition-[border] duration-200 rounded-md" style={{
          borderBottomColor: "var(--muted-foreground)",
          color: "var(--foreground)"
        }} {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="email" rules={{
      required: "L'email è obbligatoria",
      pattern: {
        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        message: "Inserisci un'email valida"
      }
    }} render={({
      field
    }) => <FormItem>
            <FormLabel className="text-xs uppercase font-mono" style={{
        letterSpacing: "0.2em",
        color: "var(--muted-foreground)"
      }}>
              Indirizzo Email
            </FormLabel>
            <FormControl>
              <Input type="email" placeholder="m.rossi@azienda.it" className="bg-transparent border-0 border-b px-0 focus-visible:ring-0 focus-visible:border-b-2 transition-[border] duration-200 rounded-md" style={{
          borderBottomColor: "var(--muted-foreground)",
          color: "var(--foreground)"
        }} {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="phone" render={({
      field
    }) => <FormItem>
            <FormLabel className="text-xs uppercase font-mono" style={{
        letterSpacing: "0.2em",
        color: "var(--muted-foreground)"
      }}>
              Recapito Telefonico
            </FormLabel>
            <FormControl>
              <Input type="tel" placeholder="+39 02 1234567" className="bg-transparent border-0 border-b px-0 focus-visible:ring-0 focus-visible:border-b-2 transition-[border] duration-200 rounded-md" style={{
          borderBottomColor: "var(--muted-foreground)",
          color: "var(--foreground)"
        }} {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="company" render={({
      field
    }) => <FormItem>
            <FormLabel className="text-xs uppercase font-mono" style={{
        letterSpacing: "0.2em",
        color: "var(--muted-foreground)"
      }}>
              Azienda / Organizzazione
            </FormLabel>
            <FormControl>
              <Input placeholder="S.p.A. Manifatturiera" className="bg-transparent border-0 border-b px-0 focus-visible:ring-0 focus-visible:border-b-2 transition-[border] duration-200 rounded-md" style={{
          borderBottomColor: "var(--muted-foreground)",
          color: "var(--foreground)"
        }} {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="inquiry_type" rules={{
      required: "Seleziona un motivo per il contatto"
    }} render={({
      field
    }) => <FormItem>
            <FormLabel className="text-xs uppercase font-mono" style={{
        letterSpacing: "0.2em",
        color: "var(--muted-foreground)"
      }}>
              Area di Interesse
            </FormLabel>
            <FormControl>
              <select {...field} className="w-full bg-transparent border-0 border-b px-0 py-2 focus:outline-none focus:border-b-2 transition-[border] duration-200 font-default rounded-md" style={{
          borderBottomColor: "var(--muted-foreground)",
          color: "var(--foreground)"
        }}>
                <option value="">Seleziona un'opzione</option>
                <option value="Sviluppo Web B2B">Sviluppo Web B2B</option>
                <option value="SEO Internazionale">SEO Internazionale</option>
                <option value="Ricerca Partner Esteri">Ricerca Partner Esteri</option>
                <option value="Neuromarketing Strategico">Neuromarketing Strategico</option>
                <option value="Altro">Altro</option>
              </select>
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="message" rules={{
      required: "Un breve messaggio è richiesto",
      minLength: {
        value: 10,
        message: "Minimo 10 caratteri"
      }
    }} render={({
      field
    }) => <FormItem>
            <FormLabel className="text-xs uppercase font-mono" style={{
        letterSpacing: "0.2em",
        color: "var(--muted-foreground)"
      }}>
              Dettagli del Progetto
            </FormLabel>
            <FormControl>
              <Textarea placeholder="Descriva brevemente i suoi obiettivi di espansione..." rows={4} className="bg-transparent border-0 border-b px-0 focus-visible:ring-0 focus-visible:border-b-2 transition-[border] duration-200 resize-none rounded-md" style={{
          borderBottomColor: "var(--muted-foreground)",
          color: "var(--foreground)"
        }} {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <div className="flex items-start gap-3 pt-2">
        <Checkbox id="privilege-ack" className="mt-1 rounded-md" style={{
        borderColor: "var(--foreground)"
      }} />
        <label htmlFor="privilege-ack" className="text-sm leading-relaxed font-default cursor-pointer" style={{
        color: "var(--muted-foreground)"
      }}>
          Accetto il trattamento dei dati per fini di consulenza strategica.
        </label>
      </div>

      {submitError && <div className="p-4 border rounded-md" style={{
      borderColor: "var(--destructive)",
      backgroundColor: "hsl(0 84% 60% / 0.08)"
    }}>
          <p className="text-sm" style={{
        color: "var(--destructive)"
      }}>
            {submitError}
          </p>
        </div>}

      <div className="pt-2">
        <Button type="submit" disabled={isSubmitting} className="rounded-md px-7 py-6 text-base font-default font-bold shadow-md hover:opacity-90 transition-opacity uppercase tracking-widest" style={{
        backgroundColor: "var(--primary)",
        color: "var(--primary-foreground)"
      }}>
          {isSubmitting ? "Invio in corso..." : "Invia Richiesta"}
        </Button>
        <p className="mt-3 font-mono text-xs uppercase tracking-widest" style={{
        color: "var(--foreground)",
        transform: "rotate(0deg)",
        transformOrigin: "left center"
      }}>
          ↳ protocollo crittografato
        </p>
      </div>
    </Form>;
}
export default function AccessTheNetwork() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="1712" id="access-the-network" className="relative overflow-hidden bg-background py-24 md:py-44 text-foreground">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute -left-24 bottom-0 w-[42rem] h-[42rem] opacity-5" style={{
      background: "radial-gradient(ellipse 60% 70% at 45% 55%, var(--accent-foreground) 0%, var(--accent-foreground) 40%, transparent 70%)",
      clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)"
    }} />

      <div ref={ref} className={`relative max-w-[1440px] mx-auto px-6 md:px-8 lg:px-20 transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
          {}
          <div className="lg:col-span-7">
            {}
            <div className="flex items-baseline gap-4 mb-8">
              <span className="font-mono text-xs uppercase" style={{
              letterSpacing: "0.2em",
              color: "var(--muted-foreground)"
            }}>
                § 04 / Accesso Rete
              </span>
              <span className="font-mono text-xs uppercase tracking-widest" style={{
              color: "var(--primary)"
            }}>
                intelligence hub
              </span>
            </div>

            <h2 className="font-default text-4xl md:text-5xl lg:text-6xl leading-[1.1] mb-8 uppercase" style={{
            color: "var(--foreground)",
            letterSpacing: "-0.02em",
            fontWeight: 700
          }}>
              Inizi una{" "}
              <span className="relative inline-block">
                <span className="font-default italic" style={{
                color: "var(--primary)"
              }}>
                  analisi
                </span>
                <svg className="absolute left-0 -bottom-2 w-full" height="4" viewBox="0 0 120 4" preserveAspectRatio="none" aria-hidden="true">
                  <path d="M0,2 L120,2" fill="none" stroke="var(--primary)" strokeWidth="2" strokeLinecap="square" style={{
                  strokeDasharray: 200,
                  strokeDashoffset: isVisible ? 0 : 200,
                  transition: "stroke-dashoffset 900ms ease-out 400ms"
                }} />
                </svg>
              </span>{" "}
              strategica.
            </h2>

            <p className="text-lg md:text-xl leading-relaxed mb-12 max-w-xl font-default" style={{
            color: "var(--muted-foreground)"
          }}>
              Definisca i contorni del suo mercato. Rispondiamo entro quattordici ore con una valutazione preliminare di fattibilità logistica e posizionamento SEO.
            </p>

            <FormProvider formKey="access_network_form_home" formId="access_network_form_home" sectionName="reach-out-section" defaultValues={{
            name: "",
            email: "",
            phone: "",
            company: "",
            inquiry_type: "",
            message: ""
          }} validationRules={{
            name: {
              required: true,
              minLength: 2
            },
            email: {
              required: true,
              pattern: "email"
            },
            inquiry_type: {
              required: true
            },
            message: {
              required: true,
              minLength: 10
            }
          }} submitText="Invia Richiesta" successMessage="Ricevuto. La sua richiesta è in fase di analisi — riceverà un riscontro tecnico entro quattordici ore." errorMessage="Impossibile inviare il messaggio. Riprovi o utilizzi i canali diretti.">
              <ReachOutForm />
            </FormProvider>
          </div>

          {}
          <div className="lg:col-span-5">
            {}
            <p className="font-default font-bold text-2xl md:text-3xl mb-6 inline-block uppercase tracking-tight" style={{
            color: "var(--foreground)"
          }}>
              Direct Intelligence Line
            </p>

            {}
            <div className="relative p-8 md:p-10 shadow-md border" style={{
            backgroundColor: "var(--card)",
            borderColor: "var(--border)",
            borderRadius: "0px"
          }}>
              <h3 className="font-default text-2xl md:text-3xl mb-8 uppercase" style={{
              color: "var(--foreground)",
              fontWeight: 600,
              letterSpacing: "-0.01em"
            }}>
                Headquarters
              </h3>

              <div className="space-y-6">
                {}
                <div className="flex items-start gap-4">
                  <MapPin className="size-5 mt-1 shrink-0" style={{
                  color: "var(--accent-foreground)",
                  strokeWidth: 1.5
                }} />
                  <address className="not-italic font-default text-sm leading-relaxed" style={{
                  color: "var(--foreground)"
                }}>
                    Via della Spiga, 15
                    <br />
                    20121 Milano, Italia
                  </address>
                </div>

                <Separator style={{
                backgroundColor: "var(--border)"
              }} />

                {}
                <div className="flex items-start gap-4">
                  <Phone className="size-5 mt-1 shrink-0" style={{
                  color: "var(--accent-foreground)",
                  strokeWidth: 1.5
                }} />
                  <Link to="tel:+39021234567" className="font-default text-sm hover:text-primary transition-colors" style={{
                  color: "var(--foreground)"
                }}>
                    +39 02 1234 567
                  </Link>
                </div>

                <Separator style={{
                backgroundColor: "var(--border)"
              }} />

                {}
                <div className="flex items-start gap-4">
                  <Mail className="size-5 mt-1 shrink-0" style={{
                  color: "var(--accent-foreground)",
                  strokeWidth: 1.5
                }} />
                  <Link to="mailto:intelligence@geroi.eu" className="font-default text-sm break-all hover:text-primary transition-colors" style={{
                  color: "var(--foreground)"
                }}>
                    intelligence@geroi.eu
                  </Link>
                </div>

                <Separator style={{
                backgroundColor: "var(--border)"
              }} />

                {}
                <div className="flex items-start gap-4">
                  <Clock className="size-5 mt-1 shrink-0" style={{
                  color: "var(--accent-foreground)",
                  strokeWidth: 1.5
                }} />
                  <div className="grid grid-cols-2 gap-x-6 gap-y-2 font-mono text-xs uppercase" style={{
                  letterSpacing: "0.12em",
                  color: "var(--muted-foreground)"
                }}>
                    <span>Lun — Ven</span>
                    <span>08:00 — 19:00</span>
                    <span>Sab — Dom</span>
                    <span>Solo Emergenze</span>
                  </div>
                </div>
              </div>

              {}
              <div className="absolute -bottom-6 -right-6 size-24 flex items-center justify-center" style={{
              transform: "rotate(0deg)"
            }}>
                <div className="relative size-full flex items-center justify-center shadow-lg" style={{
                backgroundColor: "var(--secondary)",
                borderRadius: "0px",
                border: "1px solid var(--primary)"
              }}>
                  <svg viewBox="0 0 100 100" className="absolute inset-0 w-full h-full" aria-hidden="true">
                    <defs>
                      <path id="seal-circle" d="M 50,50 m -36,0 a 36,36 0 1,1 72,0 a 36,36 0 1,1 -72,0" />
                    </defs>
                    <text style={{
                    fontFamily: "var(--font-mono)",
                    fontSize: "8px",
                    letterSpacing: "0.2em",
                    fill: "var(--primary)"
                  }}>
                      <textPath href="#seal-circle" startOffset="0">
                        · GEROI · INTELLIGENCE · 2024 ·
                      </textPath>
                    </text>
                  </svg>
                  <span className="font-default text-xs font-bold text-center leading-tight relative z-10 uppercase" style={{
                  color: "var(--primary)"
                }}>
                    B2B
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}